var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"py-1",attrs:{"header-tag":"h3"}},[_vm._t("categoryHeader",null,null,_vm.category),_vm._v(" "+_vm._s(_vm.category.DisplayName)+" ")],2),_c('b-card-body',{staticClass:"p-1 w-auto"},[_vm._v(" Preview Disabled for the Category Level. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }